import React, { useEffect, useState, useRef } from 'react';
import { Leaf } from 'lucide-react';

export const CounterDisplay = ({ value, loading }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const prevValueRef = useRef(0);

  useEffect(() => {
    if (loading) return;
    
    const startValue = prevValueRef.current;
    const endValue = value;
    
    if (startValue === endValue) return;
    
    setIsAnimating(true);
    const duration = 2000; // 2 seconds
    const steps = 60;
    const increment = (endValue - startValue) / steps;
    const stepDuration = duration / steps;
    
    let currentStep = 0;
    
    const timer = setInterval(() => {
      currentStep++;
      const newValue = Math.floor(startValue + (increment * currentStep));
      setDisplayValue(newValue);
      
      if (currentStep >= steps) {
        clearInterval(timer);
        setDisplayValue(endValue);
        prevValueRef.current = endValue;
        setIsAnimating(false);
      }
    }, stepDuration);
    
    return () => clearInterval(timer);
  }, [value, loading]);

  return (
    <div className="mb-12 relative">
      <div className="relative bg-gradient-to-br from-card to-card/80 backdrop-blur-sm rounded-3xl p-12 shadow-lg border border-border overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-accent/10 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-primary/10 to-transparent rounded-full blur-3xl"></div>
        
        <div className="relative z-10 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-primary to-accent mb-6 shadow-lg animate-float">
            <Leaf className="w-10 h-10 text-primary-foreground" />
          </div>
          
          <h2 className="text-lg md:text-xl text-muted-foreground font-medium mb-4">
            Single-Use Plastic Bottles Prevented
          </h2>
          
          <div className="mb-6">
            <div className={`text-6xl md:text-8xl lg:text-9xl font-bold bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent ${isAnimating ? 'animate-count-up' : ''}`}
                 style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {displayValue.toLocaleString()}
            </div>
          </div>
          
          <div className="flex items-center justify-center gap-3 text-muted-foreground">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-border"></div>
            <p className="text-sm md:text-base">
              and counting, thanks to our customers
            </p>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-border"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterDisplay;
